import * as React from 'react';
import injectSheet from 'react-jss';
import { Spin, Icon } from 'antd';
import { StylesProps } from 'src/Library/Types';

const styles = theme => ({
  loaderContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
    zIndex: -1,
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  zIndex: number;
  top: number | string;
  left: number | string;
  style: React.CSSProperties;
  backgroundColor: string;
}

class Loader extends React.Component<IProps, any> {
  render() {
    const { classes, zIndex, top, left, style, backgroundColor } = this.props;
    return (
      <div className={classes.loaderContainer} style={{
        ...(style || {}),
        zIndex: zIndex ? zIndex : -1,
        top: top ? top : 0,
        left: left ? left : 0,
        backgroundColor: backgroundColor ? backgroundColor : undefined }}>
        <Spin indicator={
          <Icon type="loading" style={{
            fontSize: 40,
          }} spin />
        } />
      </div>

    );
  }
}
export default injectSheet(styles)(Loader);
